import {commonPalette} from './palette';

export const truncate = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const lineClamp = (lines: number) => `
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const interactionStates = `
  &:hover {
    background: ${commonPalette.interactionHover};
  }

  &:active {
    background: ${commonPalette.interactionPressed};
  }

  &:focus-visible {
    background: ${commonPalette.interactionHover};
    box-shadow: ${commonPalette.focusShadow};
    outline: none;
  }
`;

export const anchorColor = (color: string) => `
  &,
  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    color: ${color};
  }
`;
